/**
 * @fileoverview POST handler for the "/:app_group_id/braze_docs/fallback_search" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppGroupIdBrazeDocsFallbackSearchCacheKeys } from "./constants";
import type {
  PostAppGroupIdBrazeDocsFallbackSearchErrors,
  PostAppGroupIdBrazeDocsFallbackSearchProps,
  PostAppGroupIdBrazeDocsFallbackSearchResult,
} from "./types";

export const postAppGroupIdBrazeDocsFallbackSearch = reactQueryMutationAdapter(
  postAppGroupIdBrazeDocsFallbackSearchCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAppGroupIdBrazeDocsFallbackSearchErrors>()(
    (props: PostAppGroupIdBrazeDocsFallbackSearchProps): Promise<PostAppGroupIdBrazeDocsFallbackSearchResult> => {
      return fetch(
        `/${props.appGroupId}/braze_docs/fallback_search`,
        "POST",
        {
          search_string: props.searchString,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
